var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009587",
    d: "m6.5 2c-0.831 0-1.5 0.669-1.5 1.5v25c0 0.831 0.669 1.5 1.5 1.5h19c0.831 0 1.5-0.669 1.5-1.5v-25c0-0.831-0.669-1.5-1.5-1.5h-19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m6.5 2c-0.831 0-1.5 0.669-1.5 1.5v25c0 0.831 0.669 1.5 1.5 1.5h2.5v-28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m19 3v14l2-2 2 2v-14h-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "m19 2v14l2-2 2 2v-14h-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.2,
    d: "m6.5 2c-0.831 0-1.5 0.669-1.5 1.5v1c0-0.831 0.669-1.5 1.5-1.5h19c0.831 0 1.5 0.669 1.5 1.5v-1c0-0.831-0.669-1.5-1.5-1.5h-19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m5 28.5v1c0 0.831 0.669 1.5 1.5 1.5h19c0.831 0 1.5-0.669 1.5-1.5v-1c0 0.831-0.669 1.5-1.5 1.5h-19c-0.831 0-1.5-0.669-1.5-1.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#c03630",
    fillRule: "evenodd",
    cx: 24,
    cy: 23,
    r: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m24 19.75c-0.96927 0.0095-1.945 0.2309-2.7893 0.70939-0.33651 0.21919-0.74047 0.50229-1.0449 0.78752-0.479 0.469-0.889 1.016-1.166 1.629 0.75934 1.6751 2.4287 2.9028 4.2651 3.0842 1.2046 0.13636 2.4653-0.07179 3.5242-0.66786 0.3365-0.21919 0.74047-0.50229 1.0449-0.78752 0.479-0.47 0.889-1.017 1.166-1.629-0.759-1.675-2.429-2.903-4.265-3.084-0.244-0.029-0.49-0.042-0.735-0.042zm0 1.2503c1.0044-0.02225 1.8939 0.87633 1.875 1.8754 0.03219 1.1042-1.0681 2.0572-2.1558 1.851-1.0985-0.12898-1.8701-1.3614-1.5088-2.4053 0.231-0.768 0.985-1.33 1.79-1.321zm0 1.2503a0.625 0.62514 0 0 0 -0.625 0.626 0.625 0.62514 0 0 0 0.625 0.625 0.625 0.62514 0 0 0 0.625 -0.625 0.625 0.62514 0 0 0 -0.625 -0.625z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    opacity: 0.2,
    d: "m31.979 23.424a8 8 0 0 1 -7.979 7.576 8 8 0 0 1 -7.979 -7.424 8 8 0 0 0 -0.021 0.424 8 8 0 0 0 8 8 8 8 0 0 0 8 -8 8 8 0 0 0 -0.021 -0.576z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewer);
export default __webpack_public_path__ + "static/media/viewer.209be3dbc8456ce8ac6bc31ac8e66a17.svg";
export { ForwardRef as ReactComponent };